// Customers actions
import axios from 'axios';
import types from '../../../../types';
/* eslint-disable */
export default {
  [types.GET_INVOICE_ITEMS]: async (context, payload) => {
    try {
      await axios.get(`admin-vendor-invoice/get-vendor-invoice-items/${payload.id}?page=${payload.page}${payload.query}`).then((res) => {
        if (payload.page == 1) {
          context.commit('CLEAR_INVOICE_ITEMS');
          context.commit('STORE_INVOICE_ITEMS', res.data.data);
        } else {
          context.commit('STORE_INVOICE_ITEMS', res.data.data);
        }
      });
    } catch (err) {
      console.error(err);
    }
  },
  [types.STORE_INVOICE_ITEMS]: ({ commit }, payload) => {
    commit('STORE_INVOICE_ITEMS', payload);
  },
  [types.CLEAR_INVOICE_ITEMS]: (context) => {
    context.commit('CLEAR_INVOICE_ITEMS');
  },
}
